import React, { useEffect, useState, useRef } from "react";
import { OverlayPanel } from "primereact/overlaypanel";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
// import { InputMask } from "primereact/inputmask";
import { Calendars } from "../../../components/Calendar/Calendar";
import { Checkbox } from "primereact/checkbox";
import { Galleria } from "primereact/galleria";
// import { InputNumber } from "primereact/inputnumber";
import { DialogDelete, DialogConfirm } from "../../../components/DialogService/DialogService";
import { FooterButtonCenter, FooterButtonCustomLabel, FooterButtonSuccess, FooterButtonSigle } from "../../../components/FooterButton/FooterButton";
import { Loading } from "../../../components/Loading/Loading";
import { validateInputText } from "../../../utilities/ValidateUtil";
import { useLocation } from "react-router-dom";
import { dataUserSession } from "../../../utilities/dataSession";
import { useHistory } from "react-router-dom";
import { formatDateAPI, formatDateAPI_V2 } from "../../../utilities/DateUtil";
import ValidateService from "../../../components/ValidateService/ValidateService";
// Util
import { srcImagesFile } from "../../../utilities/FileUtil";
//PAGE
import P104List from "./P104List";

//SERVICE
import { pContractorOrderInfo, pContractorOrderUpdate, pContractorOrderPhoto } from "../../../service/100/P104Service";
import { genForemanList } from "../../../service/GEN/GenService";

export default function P104() {
    const location = useLocation();
    const history = useHistory();
    const op = useRef(null);

    const toast = useRef(null);
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [dataObjTb, setDataObjTb] = useState([]);
    const [dataTable, setDataTable] = useState([]);
    const [formObject, setFormObject] = useState({
        seqPk: "",
        displayMode: "",
        requestNo: "",
        contractNo: "",
        requestType: "",
        routeNo: "",
        orderDate: "",
        orderDetail: "",
        guidelineCheckbox: null,
        guidelineNo: null,
        fixExpireCheckbox: null,
        fixExpireDate: "",
        urgentFixExpireCheckbox: null,
        urgentFixExpireDate: "",
        replyExpireCheckbox: null,
        replyExpireDate: "",
        replyWithinDay: null,
        locationBegin: null,
        locationEnd: null,
        operateDate: null,
        photoPath: null,
        photoSeq: null,
        operateTimeBegin: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), "09", "00"),
        operateTimeEnd: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), "16", "00"),
        foremanId: 0,
        originalRequestNo: null,
        recordStamp: 0,
    });
    const [checkboxValue, setCheckboxValue] = useState([]);
    const [images, setImages] = useState([]);

    const [foreMan, setForeMan] = useState([]);
    const [errData, setErrData] = useState(null);

    const [showDialog, setShowDialog] = useState(false);

    const [countBtnSave, setCountBtnSave] = useState(0);

    const [dialogOption, setdialogOption] = useState({
        header: "แจ้งเตือน",
        content: "",
        onConfirm: () => {},
        onCancle: () => {},
        footerBtn: () => {},
    });

    const [searchData, setSearchData] = useState({
        orderNo: "", // S651600003
        requestNo: "", //"R651600024",
        contractNo: "",
        action: "NEW",
        form: "",
        userId: dataUserSession() ? dataUserSession().userId : "",
        ...(history.location.state ? history.location.state : ""),
    });

    useEffect(() => {
        if (dataUserSession()) {
            if (!location.state) {
                history.push("/100");
            }
        } else {
            history.push("/login");
        }
    }, []);

    useEffect(() => {

        if (searchData.form === "103" || searchData.form === "107") {
            if (searchData.orderNo !== "") {
                getData();
                getPic();
            }
        } else {
            if (searchData.requestNo !== "") {
                getData();
                getPic();
            }
        }
    }, [searchData]);

    const getPic = () => {
        const req = {
            orderNo: searchData.orderNo,
            requestNo: searchData.requestNo,
            userId: dataUserSession().userId,
        };
        pContractorOrderPhoto(req).then(
            (res) => {
                setLoading(false);
                if (res.status === 200) {
                    let temp = [];
                    let index = 1;
                    if (res.data.length > 0) {
                        res.data.forEach((element) => {
                            temp.push({
                                ...element,
                                id: index,
                            });
                            index++;
                        });
                        setImages(temp);
                    }
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };
    const handlerBackPage = () => {
        if (location.state !== undefined) {
            history.push(`/${searchData.form}`);
        }
    };
    const getData = () => {
        // console.log("getData");
        setLoading(true);
        const req = {
            orderNo: searchData.orderNo,
            requestNo: searchData.requestNo,
            userId: dataUserSession().userId,
        };
        pContractorOrderInfo(req).then(
            (res) => {
                // console.log(res);
                setLoading(false);
                if (res.status === 200) {
                    if (res.data.length > 0) {
                        const _data = res.data[0];
                        // console.log("pContractorOrderInfo", _data);
                        setDataTable(res.data);
                        setFormObject({
                            ...formObject,
                            ..._data,
                            operateTimeBegin: _data.operateTimeBegin === null ? new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), "09", "00") : _data.operateTimeBegin,
                            operateTimeEnd: _data.operateTimeEnd === null ? new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), "16", "00") : _data.operateTimeEnd,
                        });
                    } else {
                        // handlerBackPage();
                    }
                    getForemanList(dataUserSession().userId, searchData.contractNo);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };
    const getForemanList = (userId, contractNo) => {
        const req = {
            contractNo: contractNo,
            userId: userId,
        };
        genForemanList(req).then(
            (res) => {
                setLoading(false);
                if (res.status === 200) {
                    let arr = [];
                    res.data.map((item, index) => {
                        if (item.foremanFullName != null) arr.push({ name: item.foremanFullName, code: item.foremanId });
                    });
                    setForeMan(arr);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const validation = (object) => {
        if (object.operateDate === null || object.operateTimeBegin === null || object.operateTimeEnd === null || object.foremanId === null) {
            setSubmitted(true);
            return false;
        } else {
            setSubmitted(false);
            return true;
        }
    };

    // setting Dialog
    const footerButtonCon = (act) => {
        return (
            <FooterButtonCustomLabel
                labelCon="ยืนยัน"
                lableCan="ยกเลิก"
                onClickOk={() => {
                    submitForm(act);
                    setShowDialog(false);
                }}
                onClickCancle={() => setShowDialog(false)}
            />
        );
    };

    const handlerSettingDialogConfirm = (key) => {
        switch (key) {
            case "D":
                setdialogOption({
                    ...dialogOption,
                    header: "",
                    content: "ต้องการยกเลิกใบแจ้งฯนี้หรือไม่",
                    footerBtn: () => footerButtonCon(key),
                    onCancle: () => setdialogOption(false),
                });
                break;

            case "S":
                setdialogOption({
                    ...dialogOption,
                    header: "",
                    content: "ต้องการส่งข้อมูลให้ผู้คุมงานหรือไม่",
                    footerBtn: () => footerButtonCon(key),
                    onCancle: () => setdialogOption(false),
                });
                break;

            default:
                break;
        }

        setShowDialog(true);
    };

    const footerButtonClose = () => {
        return (
            <FooterButtonSigle
                btnLabel="ปิด"
                onClick={() => {
                    setShowDialog(false);
                }}
            />
        );
    };

    const footerButtonSave = (res) => {
        return (
            <FooterButtonSigle
                btnLabel="ปิด"
                onClick={() => {
                    if (res.data[0].statusText.split(" ")[1] !== undefined) {
                        setSearchData({ ...searchData, requestNo: res.data[0].statusText.split(" ")[1], form: "", orderNo: "" });
                    }
                    setShowDialog(false);
                }}
            />
        );
    };

    const footerButtonA = () => {
        return (
            <FooterButtonSigle
                btnLabel="ตกลง"
                onClick={() => {
                    getPic(searchData.requestNo);
                    getData();
                    setShowDialog(false);
                }}
            />
        );
    };

    const footerButtonS = () => {
        return (
            <FooterButtonSigle
                btnLabel="ปิด"
                onClick={() => {
                    history.push("/100");
                    setShowDialog(false);
                }}
            />
        );
    };

    const footerButtonD = () => {
        return (
            <FooterButtonSigle
                btnLabel="ปิด"
                onClick={() => {
                    getPic(searchData.requestNo);
                    getData();
                    setShowDialog(false);
                }}
            />
        );
    };

    const submitForm = (act) => {
        if (validation(formObject)) {
            setLoading(true);
            let _actionCode = "";
            if (act === "INS") {
                if (searchData.form === "103" || searchData.form == "107") {
                    _actionCode = "A";
                } else {
                    _actionCode = "U";
                }
            } else {
                _actionCode = act;
            }

            const req = {
                actionCode: _actionCode,
                foremanId: formObject.foremanId,
                operateDate: formatDateAPI(formObject.operateDate, false),
                operateTimeBegin: formObject.operateTimeBegin === "" ? "" : formatDateAPI_V2(formObject.operateTimeBegin, true),
                operateTimeEnd: formObject.operateTimeEnd === "" ? "" : formatDateAPI_V2(formObject.operateTimeEnd, true),
                orderNo: searchData.orderNo,
                requestNo: searchData.requestNo,
                userId: dataUserSession().userId,
                recordStamp: formObject.recordStamp === null ? 0 : formObject.recordStamp,
            };

            // console.log(req);
            pContractorOrderUpdate(req).then(
                (res) => {
                    setLoading(false);
                    if (res.status === 200) {
                        if (res.data[0].statusText === "") {
                            if (res.data[0].statusCode === "C") {
                                setdialogOption({ ...dialogOption, content: "บันทึกสำเร็จ", footerBtn: () => footerButtonA() });
                            } else if (res.data[0].statusCode === "E") {
                                setdialogOption({ ...dialogOption, content: "มีข้อผิดพลาด", footerBtn: () => footerButtonClose() });
                            }
                        } else {
                            if (res.data[0].statusText.split(" ")[1] !== undefined) {
                                setSearchData({ ...searchData, requestNo: res.data[0].statusText.split(" ")[1], form: "" });
                                getPic(searchData.requestNo);
                                getData();
                            }

                            if (_actionCode === "A") {
                                getData();
                                setCountBtnSave(1);
                                setdialogOption({ ...dialogOption, content: `${res.data[0].statusText}`, footerBtn: () => footerButtonSave(res) });
                            }

                            if (_actionCode === "U") {
                                getData();
                                setCountBtnSave(1);
                                setdialogOption({ ...dialogOption, content: `${res.data[0].statusText}`, footerBtn: () => footerButtonClose() });
                            }

                            if (_actionCode === "S") {
                                setdialogOption({ ...dialogOption, content: res.data[0].statusCode === "C" ? "ส่งผู้คุมงานเรียบร้อยแล้ว" : res.data[0].statusText, footerBtn: () => footerButtonS() });
                            }

                            if (_actionCode === "D") {
                                setdialogOption({ ...dialogOption, content: `${res.data[0].statusText}`, footerBtn: () => footerButtonD() });
                            }
                        }
                        setShowDialog(true);
                    } else {
                        showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                    }
                },
                function (err) {
                    // console.log(err);
                    setLoading(false);
                    setErrData(err);
                }
            );
        }
    };

    const footerButton = () => {
        const handlerDeleteData = () => {
            const _filter = dataObjTb.filter((data) => data.seqPK != deleteDialog.data.seqPK);
            setDataObjTb(_filter);
            setDeleteDialog(false);
        };

        return <FooterButtonCenter onClickOk={() => handlerDeleteData()} onClickCancle={() => setDeleteDialog(false)} />;
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const galleriaResponsiveOptions = [
        {
            breakpoint: "1024px",
            numVisible: 5,
        },
        {
            breakpoint: "768px",
            numVisible: 3,
        },
        {
            breakpoint: "560px",
            numVisible: 1,
        },
    ];

    const onCheckboxChange = (e) => {
        let selectedValue = [...checkboxValue];
        if (e.checked) selectedValue.push(e.value);
        else selectedValue.splice(selectedValue.indexOf(e.value), 1);

        setCheckboxValue(selectedValue);
    };

    const galleriaItemTemplate = (item) => {
        return (
            <>
                <img
                    {...srcImagesFile(item.photoPath)}
                    alt={item.alt}
                    style={{ width: "100%", height: "380px", display: "block" }}
                    //onClick={toggle}
                />
                <OverlayPanel ref={op} appendTo={document.body} showCloseIcon>
                    <img {...srcImagesFile(item.photoPath)} style={{ width: "100%" }} />
                </OverlayPanel>
            </>
        );
    };
    const galleriaThumbnailTemplate = (item) => <img {...srcImagesFile(item.photoPath)} alt={item.alt} style={{ width: "100px", height: "80px", display: "block" }} />;

    const display_mode = () => {
        // return false;
        return formObject.displayMode === "Y" ? true : false;
    };

    const disBtnSave = () => {
        // return false;
        return formObject.displayMode === "Y" || countBtnSave !== 0 ? true : false;
    };

    const dis = () => {
        // return false;
        if (formObject.displayMode === "Y") {
            return true;
        } else {
            if (countBtnSave === 0) {
                return true;
            } else {
                return false;
            }
        }
    };

    // console.log(formObject.operateTimeBegin);

    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="requestNo">เลขที่ใบแจ้งฯ</label>
                                <InputText id="requestNo" type="text" value={formObject.requestNo} maxLength="20" disabled={true} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="requestType">ประเภทงาน</label>
                                <InputText id="requestType" type="text" value={formObject.requestType} maxLength="100" disabled={true} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="contractNo">เลขที่สัญญา</label>
                                <InputText id="contractNo" type="text" value={formObject.contractNo} maxLength="20" disabled={true} />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="routeName">เส้นทาง</label>
                                <InputText id="routeName" type="text" value={formObject.routeName} maxLength="5" disabled={true} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="order_date">วันที่สั่ง</label>
                                {/* <Calendars value={_date(formObject.operate_date)}  onChange={(e) => setFormObject({ ...formObject, order_date: e.target.value })} maxLength="10" disabled={true} /> */}
                                <InputText id="orderDate" type="text" value={formObject.orderDate} maxLength="5" disabled={true} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="routeName">เลขที่ใบแจ้งฯต้นเรื่อง</label>
                                <InputText id="routeName" type="text" value={formObject.originalRequestNo == null ? "" : formObject.originalRequestNo} maxLength="5" disabled={true} />
                            </div>
                        </div>
                        <hr />
                        <div className="p-fluid p-formgrid p-grid">
                            <label htmlFor="orderDetail">งานสั่งการเฉพาะอย่าง</label>
                            <P104List dataTable={dataTable} />
                        </div>
                        <div className="p-grid nested-grid">
                            <div className="p-col-8">
                                <div className="p-grid">
                                    <div className="p-col-12">
                                        <div className="box">
                                            <div className="p-field-checkbox">
                                                <Checkbox inputId="guidelineCheckbox" checked={formObject.guidelineCheckbox === "Y" ? true : false} disabled={true} />
                                                <label htmlFor="guideline_no">เพื่อเป็นเเนวทางปฏิบัติ</label>
                                                <InputText style={{ marginLeft: "5px" }} id="guidelineNo" type="text" disabled={true} value={formObject.guidelineNo} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="p-col-12">
                                        <div className="box">
                                            <div className="p-field-checkbox">
                                                <Checkbox inputId="fixExpireCheckbox" checked={formObject.fixExpireCheckbox === "Y" ? true : false} disabled={true} />
                                                <label htmlFor="fixExpireDate">เพื่อปรับปรุงแก้ไขภายในวันที่</label>
                                                <InputText style={{ marginLeft: "5px" }} id="fixExpireDate" type="text" disabled={true} value={formObject.fixExpireDate} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="p-col-12">
                                        <div className="box">
                                            <div className="p-field-checkbox">
                                                <Checkbox inputId="urgentFixExpireCheckbox" checked={formObject.urgentFixExpireCheckbox === "Y" ? true : false} disabled={true} />
                                                <label htmlFor="urgentFixExpireDate">เพื่อเร่งรัดดำเนินการโดยด่วน ภายในวันที่</label>
                                                <InputText style={{ marginLeft: "5px" }} id="urgentFixExpireDate" type="text" disabled={true} value={formObject.urgentFixExpireDate} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="p-col-12">
                                        <div className="box">
                                            <div className="p-field-checkbox">
                                                <Checkbox inputId="replyExpireCheckbox" checked={formObject.replyExpireCheckbox === "Y" ? true : false} onChange={onCheckboxChange} disabled={true} />
                                                <label htmlFor="replyExpireDate">โปรดตอบเป็นหนังสือภายในวันที่</label>
                                                <InputText style={{ marginLeft: "5px" }} id="replyExpireDate" type="text" value={formObject.replyExpireDate} disabled={true} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="p-col-12">
                                        <div className="box">
                                            <div className="p-fluid p-formgrid p-grid">
                                                <div className="p-field p-col-12 p-md-10">
                                                    <label htmlFor="replyWithinDay">แก้ไขและตอบกลับภายใน(วัน)</label>
                                                    <InputText style={{ marginLeft: "5px" }} id="replyWithinDay" type="text" value={formObject.replyWithinDay} disabled={true} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="p-col-12 p-md-10">
                                        <div className="box">
                                            <div className="p-fluid p-formgrid p-grid">
                                                <div className="p-field p-col-12 p-md-6">
                                                    <label htmlFor="locationBegin">บริเวณก่อสร้าง</label>
                                                    {/* <InputNumber placeholder="ระบุ บริเวณก่อสร้าง" id="locationBegin" inputId="locationBegin" value={formObject.locationBegin} mode="decimal" max={99999999999} minFractionDigits={3} maxFractionDigits={3} disabled useGrouping={true} /> */}
                                                    <InputText id="locationBegin" type="text" disabled={true} maxLength="11" value={formObject.locationBegin} />
                                                </div>
                                                <div className="p-field p-col-12 p-md-6">
                                                    <label htmlFor="locationEnd">ถึง</label>
                                                    {/* <InputNumber placeholder="ระบุ ถึง" id="locationEnd" inputId="locationEnd" value={formObject.locationEnd} mode="decimal" max={99999999999} minFractionDigits={3} maxFractionDigits={3} disabled useGrouping={true} /> */}
                                                    <InputText id="locationEnd" type="text" disabled={true} maxLength="11" value={formObject.locationEnd} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="p-col-12">
                                        <div className="box">
                                            <div className="p-fluid p-formgrid p-grid">
                                                <div className="p-field p-col-12 p-md-10">
                                                    <label htmlFor="operateDate">วันที่ออกปฏิบัติงาน</label>
                                                    <span style={{ color: "red" }}>*</span>
                                                    <Calendars className={submitted && !formObject.operateDate ? "p-invalid" : ""} value={_date(formObject.operateDate)} onChange={(e) => setFormObject({ ...formObject, operateDate: e.target.value })} disabled={display_mode()} />
                                                    {submitted && !formObject.operateDate && validateInputText("operateDate", "วันที่ออกปฏิบัติงาน")}
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                    <div className="p-col-12 p-md-10">
                                        <div className="box">
                                            <div className="p-fluid p-formgrid p-grid">
                                                <div className="p-field p-col-12 p-md-6">
                                                    <label htmlFor="operateTimeBegin">วันที่เวลาออกปฏิบัติงานจาก</label>
                                                    <span style={{ color: "red" }}>*</span>
                                                    <Calendars
                                                        key="operateTimeBegin"
                                                        id="operateTimeBegin"
                                                        value={formObject.operateTimeBegin.length === 5 ? "" : new Date(formObject.operateTimeBegin)}
                                                        onChange={(e) => setFormObject({ ...formObject, operateTimeBegin: e.target.value })}
                                                        disabled={display_mode()}
                                                        showTime={true}
                                                    />
                                                    {/* <InputMask
                                                        id="operateTimeBegin"
                                                        className={submitted && !formObject.operateTimeBegin ? "p-invalid" : ""}
                                                        onChange={(e) => setFormObject({ ...formObject, operateTimeBegin: e.target.value })}
                                                        mask="99:99"
                                                        value={formObject.operateTimeBegin}
                                                        placeholder="ระบุ ช่วงเวลาจาก"
                                                        disabled={display_mode()}
                                                    /> */}
                                                    {submitted && !formObject.operateTimeBegin && validateInputText("operateTimeBegin", "วันที่เวลาออกปฏิบัติงานจาก")}
                                                </div>
                                                <div className="p-field p-col-12 p-md-6">
                                                    <label htmlFor="operateTimeEnd">วันที่เวลาออกปฏิบัติงานถึง</label>
                                                    <span style={{ color: "red" }}>*</span>
                                                    <Calendars
                                                        key="operateTimeEnd"
                                                        id="operateTimeEnd"
                                                        value={formObject.operateTimeEnd.length === 5 ? "" : new Date(formObject.operateTimeEnd)}
                                                        onChange={(e) => setFormObject({ ...formObject, operateTimeEnd: e.target.value })}
                                                        disabled={display_mode()}
                                                        showTime={true}
                                                    />
                                                    {/* <InputMask
                                                        id="operateTimeEnd"
                                                        className={submitted && !formObject.operateTimeEnd ? "p-invalid" : ""}
                                                        onChange={(e) => setFormObject({ ...formObject, operateTimeEnd: e.target.value })}
                                                        mask="99:99"
                                                        value={formObject.operateTimeEnd}
                                                        placeholder="ระบุ ถึง"
                                                        disabled={display_mode()}
                                                    /> */}
                                                    {submitted && !formObject.operateTimeEnd && validateInputText("operateTimeEnd", "วันที่เวลาออกปฏิบัติงานถึง")}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="p-col-12 p-md-10">
                                        <div className="box">
                                            <div className="p-fluid p-formgrid p-grid">
                                                <div className="p-field p-col-12 p-md-12">
                                                    <label htmlFor="foremanId">หัวหน้างาน</label>
                                                    <span style={{ color: "red" }}>*</span>
                                                    <Dropdown
                                                        className={submitted && !formObject.foremanId ? "p-invalid" : ""}
                                                        id="foremanId"
                                                        value={formObject.foremanId}
                                                        onChange={(e) => {
                                                            setFormObject({ ...formObject, foremanId: e.value });
                                                        }}
                                                        options={foreMan}
                                                        optionLabel="name"
                                                        optionValue="code"
                                                        placeholder="เลือก หัวหน้างาน"
                                                        disabled={display_mode()}
                                                    ></Dropdown>
                                                    {submitted && !formObject.foremanId && validateInputText("foremanId", "หัวหน้างาน")}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-10">
                                    <div className="box">
                                        <div className="p-fluid p-formgrid p-grid">
                                            <div className="p-field p-col-12 p-md-12">
                                                <label htmlFor="supervisorReason">เหตุผลจากผู้ควบคุมงาน</label>
                                                <InputTextarea id="supervisorReason" value={formObject.supervisorReason} rows="4" disabled={true} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="p-col-4">
                                <div className="box box-stretched">
                                    <div className="p-col-12">
                                        <div className="p-grid p-fluid media-demo" style={{ marginTop: "20%" }}>
                                            <div className="p-col-12">
                                                {images.length > 0 ? (
                                                    <Galleria value={images} responsiveOptions={galleriaResponsiveOptions} numVisible={5} style={{ maxWidth: "400px", margin: "auto" }} item={galleriaItemTemplate} thumbnail={galleriaThumbnailTemplate} />
                                                ) : (
                                                    <img
                                                        alt="babylon-layout"
                                                        src="assets/layout/images/noimage.jpg"
                                                        style={{ width: 325, marginTop: 20 }}
                                                        // style={{ width: 45, height: 56, marginTop: -12, marginLeft: -8, marginRight: 6 }}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="p-grid" style={{ textAlign: "center" }}>
                            <div className="p-col-12">
                                <div className="p-grid" style={{ textAlign: "center" }}>
                                    <div className="p-col-2"></div>
                                    <div className="p-col-4">
                                        <Button
                                            className="p-button-success p-button"
                                            icon="pi pi-save"
                                            label="บันทึก"
                                            style={{ width: 170 }}
                                            onClick={() => {
                                                submitForm("INS");
                                            }}
                                            disabled={disBtnSave()}
                                        />
                                        <Button
                                            className="p-button-secondary p-button"
                                            icon="pi pi-arrow-left"
                                            label="กลับหน้าจอหลัก"
                                            // style={{ marginLeft: '5px' }}
                                            style={{ width: 170, marginLeft: "5px" }}
                                            onClick={() => handlerBackPage()}
                                        />
                                    </div>
                                    <div className="p-col-4">
                                        {/* {searchData.requestNo != "" ? ( */}
                                        <Button
                                            className="p-button-warning p-button"
                                            icon="pi pi-sign-in"
                                            label="ส่งผู้คุมงาน"
                                            // style={{ marginLeft: '5px' }}
                                            style={{ width: 170, marginLeft: "5px" }}
                                            onClick={() => handlerSettingDialogConfirm("S")}
                                            disabled={dis()}
                                        />
                                        {/* ) : null} */}
                                        {/* {formObject.requestNo != "" ? ( */}
                                        <Button
                                            className="p-button-danger p-button"
                                            icon="pi pi-times-circle"
                                            label="ยกเลิกใบแจ้งฯนี้"
                                            // style={{ marginLeft: '5px' }}
                                            style={{ width: 170, marginLeft: "5px" }}
                                            onClick={() => handlerSettingDialogConfirm("D")}
                                            disabled={dis()}
                                        />
                                        {/* ) : null} */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <DialogDelete visible={deleteDialog.open} header="การยืนยัน" modal footer={footerButton()} onHide={() => setDeleteDialog(false)} textContent="คุณต้องการลบข้อมูล ใช่หรือไม่ ?" />
                </div>
            </div>
            <DialogConfirm visible={showDialog} header={dialogOption.header} modal footer={dialogOption.footerBtn} onHide={() => setShowDialog(false)} textContent={dialogOption.content} />

            {/* <DialogShow visible={showDialog} header="แจ้งเตือน" modal onHide={() => setShowDialog(false)} className="p-fluid" textContent={dialogOption.content} btnCancle={dialogOption.onCancle} /> */}
        </>
    );
}
